/***
 *
 *   MENU STYLES
 *   The placement half of ui-reference/src/components/ui/dropdown-menu.tsx
 *   (DropdownMenuContent's `align` / `side` / `sideOffset`). The surface itself
 *   is dropdown.tailwind.js.
 *
 **********/

const Style = {
    wrapper: 'relative shrink-0',

    // The trigger carries no chrome of its own — callers style it, exactly as
    // the reference does with `asChild`.
    trigger: 'inline-flex items-center disabled:pointer-events-none disabled:opacity-60',

    anchor: 'absolute z-50',

    // align
    start: 'left-0',
    end: 'right-0',

    // side, with the reference's sideOffset of 4
    bottom: 'top-full mt-1',
    top: 'bottom-full mb-1',
};

export default Style;
